import type { DetectedIssueDisputeAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import {
  type AssociationDefinitions,
  type GroupBy,
  type IncludeAssociations,
  includeAssociationsToSql,
  makeQueryModelV2,
  type QueryOrder,
  queryGroupByToSQL,
  queryOrderToSQL,
} from './common'
import DetectedIssueQ from './DetectedIssueQ'

const DetectedIssueDisputeQ = {
  ...makeQueryModelV2<DetectedIssueDisputeAttributes>('detected_issue_dispute')([
    'id',
    'detected_issue_id',
    'content',
    'resolved_at',
    'status',
    'created_at',
    'updated_at',
    'deleted_at',
  ]),

  associations: (): AssociationDefinitions => ({
    DetectedIssue: {
      query: DetectedIssueQ,
      foreignKey: DetectedIssueQ.id,
      sourceKey: DetectedIssueDisputeQ.detected_issue_id,
    },
  }),

  where: (
    {
      id,
      detectedIssueId,
      include = [],
      groupBy = null,
      order = null,
    }: {
      id?: number | null
      detectedIssueId?: number | null | SQLFragment<number>
      include?: IncludeAssociations
      groupBy?: GroupBy | null
      order?: QueryOrder | null
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<DetectedIssueDisputeAttributes> => SQL`
            FROM ${DetectedIssueDisputeQ}
            ${includeAssociationsToSql(DetectedIssueDisputeQ, include)}
            WHERE
                ${id != null ? SQL`${DetectedIssueDisputeQ.id} = ${id} AND` : SQL``}
                ${
                  detectedIssueId != null
                    ? SQL`${DetectedIssueDisputeQ.detected_issue_id} = ${detectedIssueId} AND`
                    : SQL``
                }
                ${customWhere != null ? customWhere : SQL`TRUE`}
            ${queryGroupByToSQL(groupBy)}
            ${queryOrderToSQL(order)}
        `,
}

export default DetectedIssueDisputeQ
